'use client';
import {
  type PropsWithChildren,
  type ReactNode,
  useCallback,
  useState,
} from 'react';

import { useClickOutside } from '@quick/components/utils';
import { cn } from '@quick/utils';

import { MenuExpander } from './MenuExpander';

interface ComposableMenuProps {
  className?: string;
  banner?: ReactNode;
  options?: ReactNode;
  person?: ReactNode;
}
export function ComposableMenu({
  banner,
  children,
  className,
  options,
  person,
}: PropsWithChildren<ComposableMenuProps>) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => setIsOpen(!isOpen);

  const ref = useClickOutside<HTMLDivElement>(
    useCallback(() => {
      setIsOpen(false);
    }, [setIsOpen])
  );

  return (
    <nav
      className={cn(
        'group/menu',
        `relative flex h-full flex-col items-center bg-gray-700 transition-[width]
        focus:outline-none`,
        isOpen ? 'w-60' : 'w-20',
        className
      )}
      data-menu={isOpen ? 'open' : 'closed'}
      ref={ref}
      tabIndex={-1}
    >
      {banner}
      {person}
      <MenuExpander onClick={handleClick} />
      {options && (
        <ul
          className="relative flex min-h-0 w-full flex-1 flex-col items-center gap-2 overflow-y-auto
            overflow-x-hidden p-5 [scrollbar-width:thin]"
        >
          {options}
        </ul>
      )}
      {children}
    </nav>
  );
}
